import {createAction, props} from '@ngrx/store';
import {
  GroupDashboardParticipantInformationModel
} from 'src/app/models/group-dashboard-participant-information.model';
import {
  GroupDashboardParticipantWeightModel
} from 'src/app/models/group-dashboard-participant-weight.model';
import {
  GroupDashboardParticipantBehaviorRedLightsModel
} from 'src/app/models/group-dashboard-participant-behavior-red-lights.model';
import {
  GroupDashboardParticipantBehaviorPhysicalActivityModel
} from 'src/app/models/group-dashboard-participant-behavior-physical-activity-model';
import {
  GroupDashboardParticipantBehaviorScreenTimeModel
} from 'src/app/models/group-dashboard-participant-behavior-screen-time-model';
import {
  FetchParticipantsAndCaregiversListModel
} from '../../clients-list/model/fetch-participants-and-caregivers-list.model';
import {
  ParticipantsAndCaregiversList
} from '../../../../models/participants-and-caregivers-list';
import {Filter} from '../../../../models/filter';
import {
  FetchParticipantsWeightListModel
} from '../../clients-list/model/fetch-participants-weight-list.model';
import {
  ParticipantsWeightList
} from '../../../../models/participants-weight-list';
import {
  ParticipantsBehaviourList
} from "../../../../models/participants-behaviour-list";

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[group dashboard] clear state';
export const ClearState = createAction(CLEAR_STATE);

/********Dashboard Groups Participant Information Data***********/
const FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_REQUEST =
  '[group dashboard]  fetch group dashboard participant information data request';
export const FetchGroupDashboardParticipantInformationDataRequest =
  createAction(FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_REQUEST);

const FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_SUCCESS =
  '[group dashboard]  fetch group dashboard participant information data success';
export const FetchGroupDashboardParticipantInformationDataSuccess =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_SUCCESS,
    props<{
      groupDashboardParticipantInformation: GroupDashboardParticipantInformationModel;
      message: string;
    }>()
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_FAILURE =
  '[group dashboard]  fetch group dashboard participant information data failure';
export const FetchGroupDashboardParticipantInformationDataFailure =
  createAction(FETCH_GROUP_DASHBOARD_PARTICIPANT_INFORMATION_DATA_FAILURE);

/********Dashboard Groups Participant Weight Data***********/
const FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_REQUEST =
  '[group dashboard]  fetch group dashboard participant weight data request';
export const FetchGroupDashboardParticipantWeightDataRequest = createAction(
  FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_REQUEST
);

const FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_SUCCESS =
  '[group dashboard]  fetch group dashboard participant weight data success';
export const FetchGroupDashboardParticipantWeightDataSuccess = createAction(
  FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_SUCCESS,
  props<{
    groupDashboardParticipantWeight: GroupDashboardParticipantWeightModel;
    message: string;
  }>()
);

const FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_FAILURE =
  '[group dashboard]  fetch group dashboard participant weight data failure';
export const FetchGroupDashboardParticipantWeightDataFailure = createAction(
  FETCH_GROUP_DASHBOARD_PARTICIPANT_WEIGHT_DATA_FAILURE
);

/********Dashboard Groups Participant Behavior Red Lights Data***********/
const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_REQUEST =
  '[group dashboard]  fetch group dashboard participant behavior red lights data request';
export const FetchGroupDashboardParticipantBehaviorRedLightsDataRequest =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_REQUEST
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_SUCCESS =
  '[group dashboard]  fetch group dashboard participant behavior red lights data success';
export const FetchGroupDashboardParticipantBehaviorRedLightsDataSuccess =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_SUCCESS,
    props<{
      groupDashboardParticipantBehaviorRedLights: GroupDashboardParticipantBehaviorRedLightsModel;
      message: string;
    }>()
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_FAILURE =
  '[group dashboard]  fetch group dashboard participant behavior red lights data failure';
export const FetchGroupDashboardParticipantBehaviorRedLightsDataFailure =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_RED_LIGHTS_DATA_FAILURE
  );

/********Dashboard Groups Participant Physical Activity  Data***********/
const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_REQUEST =
  '[group dashboard]  fetch group dashboard participant physical activity data request';
export const FetchGroupDashboardParticipantBehaviorPhysicalActivityDataRequest =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_REQUEST
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_SUCCESS =
  '[group dashboard]  fetch group dashboard participant physical activity data success';
export const FetchGroupDashboardParticipantBehaviorPhysicalActivityDataSuccess =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_SUCCESS,
    props<{
      groupDashboardParticipantBehaviorPhysicalActivity: GroupDashboardParticipantBehaviorPhysicalActivityModel;
      message: string;
    }>()
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_FAILURE =
  '[group dashboard]  fetch group dashboard participant physical activity data failure';
export const FetchGroupDashboardParticipantBehaviorPhysicalActivityDataFailure =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_PHYSICAL_ACTIVITY_DATA_FAILURE
  );

/********Dashboard Groups Participant Behavior Screen Time Data***********/
const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_REQUEST =
  '[group dashboard]  fetch group dashboard participant screen time data request';
export const FetchGroupDashboardParticipantBehaviorScreenTimeDataRequest =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_REQUEST
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_SUCCESS =
  '[group dashboard]  fetch group dashboard participant screen time data success';
export const FetchGroupDashboardParticipantBehaviorScreenTimeDataSuccess =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_SUCCESS,
    props<{
      message: string;
      groupDashboardParticipantBehaviorScreenTime: GroupDashboardParticipantBehaviorScreenTimeModel;
    }>()
  );

const FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_FAILURE =
  '[group dashboard]  fetch group dashboard participant screen time data failure';
export const FetchGroupDashboardParticipantBehaviorScreenTimeDataFailure =
  createAction(
    FETCH_GROUP_DASHBOARD_PARTICIPANT_BEHAVIOR_SCREEN_TIME_DATA_FAILURE
  );

/*********** FETCH DASHBOARD FILTER **************/
const FETCH_DASHBOARD_FILTER_REQUEST = '[group dashboard] fetch dashboard filter requested';
export const FetchDashboardFilterRequest = createAction(FETCH_DASHBOARD_FILTER_REQUEST);

const FETCH_DASHBOARD_FILTER_SUCCESS = '[group dashboard] fetch dashboard filter successful';
export const FetchDashboardFilterSuccess = createAction(FETCH_DASHBOARD_FILTER_SUCCESS, props<{
  dashboardFilter: Filter,
  message: string
}>());

const FETCH_DASHBOARD_FILTER_FAILURE = '[group dashboard] fetch dashboard filter failure';
export const FetchDashboardFilterFailure = createAction(FETCH_DASHBOARD_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH PARTICIPANT AND CAREGIVERS LIST ***********/
const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST = '[group dashboard] fetch participants and caregivers list request';
export const FetchParticipantsAndCaregiversListRequest = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_REQUEST, props<{
  payload: FetchParticipantsAndCaregiversListModel['request']
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS = '[group dashboard] fetch participants and caregivers list success';
export const FetchParticipantsAndCaregiversListSuccess = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_SUCCESS, props<{
  participantsAndCaregiversList: ParticipantsAndCaregiversList,
  message: string
}>());

const FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE = '[group dashboard] fetch participants and caregivers list failure';
export const FetchParticipantsAndCaregiversListFailure = createAction(FETCH_PARTICIPANT_AND_CAREGIVERS_LIST_FAILURE);

/******** FETCH GROUPS TYPE FILTER ***********/
const FETCH_GROUPS_TYPE_FILTER_REQUEST = '[group dashboard] fetch groups type request';
export const FetchGroupsTypeFilterRequest = createAction(FETCH_GROUPS_TYPE_FILTER_REQUEST);

const FETCH_GROUPS_TYPE_FILTER_SUCCESS = '[group dashboard] fetch groups type success';
export const FetchGroupsTypeFilterSuccess = createAction(FETCH_GROUPS_TYPE_FILTER_SUCCESS, props<{
  groupsTypeFilter: Filter,
  message: string
}>());

const FETCH_GROUPS_TYPE_FILTER_FAILURE = '[group dashboard] fetch groups type failure';
export const FetchGroupsTypeFilterFailure = createAction(FETCH_GROUPS_TYPE_FILTER_FAILURE);

const FETCH_GROUP_LIST_FILTER_FAILURE = '[group dashboard] fetch group list filter failure';
export const FetchGroupListFilterFailure = createAction(FETCH_GROUP_LIST_FILTER_FAILURE, props<{
  message: string
}>());

/*********** FETCH USER STATUS FILTER LIST **************/
const FETCH_USER_STATUS_LIST_FILTER_REQUEST = '[group dashboard] fetch user status lists filter requested';
export const FetchUserStatusListFilterRequest = createAction(FETCH_USER_STATUS_LIST_FILTER_REQUEST);

const FETCH_USER_STATUS_LIST_FILTER_SUCCESS = '[group dashboard] fetch user status lists filter successful';
export const FetchUserStatusListFilterSuccess = createAction(FETCH_USER_STATUS_LIST_FILTER_SUCCESS, props<{
  data: Filter,
  message: string
}>());

const FETCH_USER_STATUS_LIST_FILTER_FAILURE = '[group dashboard] fetch user status lists filter failure';
export const FetchUserStatusListFilterFailure = createAction(FETCH_USER_STATUS_LIST_FILTER_FAILURE, props<{
  message: string
}>());

/******** FETCH PARTICIPANT WEIGHT LIST ***********/
const FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST = '[group dashboard] fetch participants weight list request';
export const FetchParticipantsWeightListRequest = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_REQUEST, props<{ payload: FetchParticipantsWeightListModel['request'] }>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS = '[group dashboard] fetch participants weight list success';
export const FetchParticipantsWeightListSuccess = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_SUCCESS, props<{
  participantsWeightList: ParticipantsWeightList,
  message: string
}>());

const FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE = '[group dashboard] fetch participants weight list failure';
export const FetchParticipantsWeightListFailure = createAction(FETCH_PARTICIPANTS_WEIGHT_LIST_FAILURE);

/*********** SAVE CONFIG ID **************/
const SAVE_CONFIG_ID = '[group dashboard] save config id';
export const SaveConfigId = createAction(SAVE_CONFIG_ID, props<{ configId: number }>());

/******** FETCH PARTICIPANT BEHAVIOUR LIST ***********/
const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST = '[group dashboard] fetch participants behaviour list request';
export const FetchParticipantsBehaviourListRequest = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_REQUEST, props<any>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS = '[group dashboard] fetch participants behaviour list success';
export const FetchParticipantsBehaviourListSuccess = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_SUCCESS, props<{
  participantsBehaviourList: ParticipantsBehaviourList,
  message: string
}>());

const FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE = '[group dashboard] fetch participants behaviour list failure';
export const FetchParticipantsBehaviourListFailure = createAction(FETCH_PARTICIPANTS_BEHAVIOUR_LIST_FAILURE);
